import { useEffect, useState } from "react";
import { Dog } from "lucide-react";

/**
 * Renders a brief "dog runs across the screen" animation whenever `trigger` changes.
 * Multiple triggers stack — each one becomes its own runner, then auto-cleans up.
 */
export default function DogRunAnimation({ trigger }) {
  const [runners, setRunners] = useState([]);

  useEffect(() => {
    if (trigger == null || trigger === 0) return;
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    setRunners((prev) => [...prev, { id, top: 30 + Math.random() * 40 }]);
    const t = setTimeout(() => {
      setRunners((prev) => prev.filter((r) => r.id !== id));
    }, 2400);
    return () => clearTimeout(t);
  }, [trigger]);

  if (runners.length === 0) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="dog-run-overlay"
      className="pointer-events-none fixed inset-0 z-[60] overflow-hidden"
    >
      {runners.map((r) => (
        <div
          key={r.id}
          className="dog-runner absolute -left-24"
          style={{ top: `${r.top}%` }}
          data-testid={`dog-runner-${r.id}`}
        >
          <div className="dog-body">
            <Dog size={48} className="text-primary drop-shadow" strokeWidth={2.2} />
          </div>
          <div className="dog-trail" />
        </div>
      ))}
    </div>
  );
}
